import { GET_ONAPPLY_JOBS } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  items: [],
};

export default function onapplyJobs(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_ONAPPLY_JOBS}_BEGIN`:
      // Mark the state as "loading" so we can show a spinner or something
      // Also, reset any errors. We're starting fresh.
      return {
        ...state,
        loading: true,
        error: null,
      };

    case `${GET_ONAPPLY_JOBS}_SUCCESS`:
      // All done: set loading "false".
      // Also, replace the items with the ones from the server
      return {
        ...state,
        loading: false,
        loaded: true,
        items: action.payload.jobs,
      };

    case `${GET_ONAPPLY_JOBS}_FAIL`:
      // The request failed. It's done. So set loading to "false".
      // Save the error, so we can display it somewhere.
      // Since it failed, we don't have items to display anymore, so set `items` empty.
      //
      // This is all up to you and your app though:
      // maybe you want to keep the items around!
      // Do whatever seems right for your use case.
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload.error,
        items: [],
      };

    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
}
